import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import harnessImage from "../assets/images/harness.png";
import { useVehicle } from "../context/VehicleContext";
const categoryMap = {
 "marine-detailing": "Marine Detailing",
 "lubricants": "Lubricants & Sprays",
 "accessories": "Accessories",
 "electronics": "Electronics",
 "new-oem": "New OEM Parts",
 "used-oem": "Used OEM Parts",
 "fluids": "Fluids & Maintenance"
};

/* ── Mobile Product Card ── */
function MobileProductCard({ item }) {
  const navigate = useNavigate();
  const today = new Date();
  const start = new Date(today); start.setDate(today.getDate() + 3);
  const end = new Date(today); end.setDate(today.getDate() + 4);
  const deliveryStr = `${start.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })} – ${end.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}`;
  const fastStr = start.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

  const displayPrice = item.variants?.length
    ? Math.min(...item.variants.map(v => v.price))
    : item.price || 0;
  const main = Math.floor(displayPrice);
  const cents = (displayPrice % 1).toFixed(2).substring(2);

  return (
    <div
      onClick={() => navigate(`/product/${item.listingId || item._id}`)}
      style={{
        display: "flex", flexDirection: "column", borderRadius: 20, padding: 14,
        background: "linear-gradient(180deg,#ffffff 0%,#f4f6ff 100%)",
        border: "2px solid #fff",
        boxShadow: "0 0 20px rgba(120,170,255,0.12), 0 10px 24px rgba(0,0,0,0.07), inset 0 1px 0 rgba(255,255,255,1)",
        cursor: "pointer", position: "relative"
      }}
    >
      {/* Stock badge */}
      <div style={{
        position: "absolute", top: 10, left: 10,
        fontSize: 9, fontWeight: 700, padding: "3px 8px", borderRadius: 999,
        background: "rgba(90,142,252,0.1)", border: "1px solid rgba(90,142,252,0.2)", color: "#3157b7"
      }}>
        {(item.unitsAvailable ?? 1) > 0 ? "In Stock" : "Out of Stock"}
      </div>

      {/* Image */}
   <div style={{ width: "100%", height: 160, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}>
  <img
 src={
  item.variants?.find(v => v.condition === "used")?.images?.[0] ||
  item.variants?.find(v => v.condition === "new")?.images?.[0] ||
  item.images?.[0] ||
  harnessImage
}
    alt={item.title}
    style={{ width: "95%", height: "95%", objectFit: "contain" }}
  />
</div>


      {/* Divider */}
      <div style={{ height: 1, background: "linear-gradient(to right, transparent, #e3e3e8, transparent)", marginBottom: 10 }} />

      {/* Info */}
      <div style={{ flex: 1 }}>
        <div style={{
          fontSize: 12, lineHeight: "17px", color: "#1d1d1f", marginBottom: 8,
          fontWeight: 500, overflow: "hidden", display: "-webkit-box",
          WebkitLineClamp: 2, WebkitBoxOrient: "vertical", textAlign: "center"
        }}>
          {item.title}
        </div>
        <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", marginBottom: 6 }}>
          <span style={{ fontSize: 12, color: "#111" }}>$</span>
          <span style={{ fontSize: 22, fontWeight: 600, letterSpacing: "-0.8px", color: "#111", lineHeight: 1 }}>{main}</span>
          <span style={{ fontSize: 12, color: "#111" }}>{cents}</span>
        </div>
        <div style={{ fontSize: 10, color: "#1d1d1f", marginBottom: 2, textAlign: "center" }}>
          FREE delivery <b>{item.delivery || deliveryStr}</b>
        </div>
        <div style={{ fontSize: 10, color: "#565959", marginBottom: 10, textAlign: "center" }}>
          ⚡ Fastest <b>{item.fastest || fastStr}</b>
        </div>
        <button
          onClick={e => { e.stopPropagation(); navigate(`/product/${item.listingId || item._id}`); }}
          style={{
            width: "100%", padding: "9px 0", borderRadius: 999, border: "none",
            background: "linear-gradient(180deg,#5a8efc,#1f57c8)", color: "#fff",
            fontSize: 12, fontWeight: 700, cursor: "pointer",
            boxShadow: "0 6px 14px rgba(62,111,227,0.3)"
          }}
        >
          Buy Now
        </button>
      </div>
    </div>
  );
}

/* ── Main ── */
export default function CategoryPageMobile() {
 const { categoryName } = useParams();
 const [listings, setListings] = useState([]);
const [loading, setLoading] = useState(true);
const { selectedVehicle, vehicleLoaded } = useVehicle();

useEffect(() => {
  if (!vehicleLoaded) return;
  let url = "https://eleven11-i6v4.onrender.com/api/listings";
  if (selectedVehicle) {
    const params = new URLSearchParams({
      year: selectedVehicle.year,
      manufacturer: selectedVehicle.manufacturer,
      model: selectedVehicle.model
    });
    url += `?${params.toString()}`;
  }
  fetch(url)
    .then(res => res.json())
    .then(data => setListings(data))
    .catch(err => console.error(err))
    .finally(() => setLoading(false));
}, [selectedVehicle, vehicleLoaded]);

 const mappedCategory = categoryMap[categoryName];

 const filtered = listings.filter(l => {
   if (categoryName === "used-oem") return l.condition === "used";
   if (categoryName === "new-oem") return l.condition === "new";
   return l.category === mappedCategory;
 });

 const displayName = categoryMap[categoryName] || categoryName;

 return (
   <div style={{ background: "#F6F7FB", minHeight: "100vh", fontFamily: "-apple-system, BlinkMacSystemFont, Inter, system-ui", paddingBottom: 40 }}>

     {/* Header */}
     <div style={{ padding: "20px 16px 16px", borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
       <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: "#9CA3AF", marginBottom: 4, textTransform: "uppercase" }}>
         ELEVEN
       </div>
       <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, letterSpacing: "-0.5px", color: "#0f0f17" }}>
         {displayName}
       </h1>
       {!loading && (
         <div style={{ fontSize: 13, color: "#9CA3AF", marginTop: 4 }}>
           {filtered.length} item{filtered.length !== 1 ? "s" : ""}
         </div>
       )}
     </div>

     {/* Results */}
  <div style={{ padding: "16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>

   {loading ? (
  <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "40px 0", color: "#9ca3af", fontSize: 14, fontWeight: 500 }}>
    Loading...
  </div>
) : filtered.length === 0 ? (
  <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "60px 20px" }}>
    <div style={{ fontSize: 36, marginBottom: 12 }}>📦</div>
    <div style={{ fontSize: 18, fontWeight: 700, color: "#111", marginBottom: 8 }}>No items found</div>
    <div style={{ fontSize: 14, color: "#8E8E93" }}>Check back soon — we're always adding new parts.</div>
  </div>
) : (
  filtered.map(item => (
    <MobileProductCard key={item._id} item={item} />
  ))
)}

     </div>
   </div>
 );
}
